import { LottoSort } from '@core/services/lotto/_private/enums';
import DateUtils from '@core/utils/date/DateUtils';

export default class LottoRequest {
    public startDate?: string;
    public endDate?: string;
    public sort?: string;
    public lottoIds?: string;

    constructor(props: LottoRequest) {
        for (const key of Object.keys(props)) {
            this[key as keyof LottoRequest] = props[key as keyof LottoRequest];
        }
    }

    static createLottoOfferRequest(startDate: Date, endDate: Date, sort: string = LottoSort.utc): LottoRequest {
        return new LottoRequest({
            sort,
            startDate: DateUtils.toString(DateUtils.inUtcTime(startDate)),
            endDate: DateUtils.toString(DateUtils.inUtcTime(endDate))
        });
    }

    static createLottoDetailsRequest(lottoIds: number[]): LottoRequest {
        return new LottoRequest({
            lottoIds: lottoIds.join(',')
        });
    }

    static createLottoEventResultsRequest(startDate: Date, endDate: Date): LottoRequest {
        return new LottoRequest({
            startDate: DateUtils.toString(DateUtils.inUtcTime(startDate)),
            endDate: DateUtils.toString(DateUtils.inUtcTime(endDate))
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lotto/_private/LottoRequest.ts